import type {
  CiTypeAccessoryDTO,
  CiTypeItemAccessoryDTO,
  CmCompletion,
  TQLNodeItemAccessoryDTO,
} from '@/entities/srm/ci';
import type { TQLFilter } from '@/entities/srm/tql-query/@x/ci';
import { type AxiosRequestConfig } from 'axios';
import { srmInstance } from '@/shared/api/api-instances/srm/api-instance';

export class AccessoriesAPI {
  static getFilters(options?: AxiosRequestConfig) {
    return srmInstance.get<CmCompletion[]>('/accessories/filters', options);
  }

  static getBlocks(options?: AxiosRequestConfig) {
    return srmInstance.get<CmCompletion[]>('/accessories/blocks', options);
  }

  static getCiTypeAccessories(name: string, options?: AxiosRequestConfig) {
    return srmInstance.get<CiTypeAccessoryDTO[]>(
      `/accessories/ci_type/${name}`,
      options,
    );
  }

  static getCiTypesAccessories(options?: AxiosRequestConfig) {
    return srmInstance.get<CiTypeItemAccessoryDTO[]>(
      `/accessories/ci_types`,
      options,
    );
  }

  static getTQLNodesAccessories(
    tqlFilter: TQLFilter,
    options?: AxiosRequestConfig,
  ) {
    return srmInstance.post<TQLNodeItemAccessoryDTO[]>(
      `/accessories/nodes`,
      tqlFilter,
      options,
    );
  }
}